module.exports = __webpack_public_path__ + "static/media/game-2-checked.178acf77.png";